
export function getTableClassNameFromCantidadDias(dias) {
    if (dias) {
        console.log(dias);
        if (dias<=30) {
            //return 'table-success';
            return 'table-light-green';
        } else if (dias<=90) {
            return 'table-green';
        } else if (dias<=150) {
            return 'table-yellow';
        } else {
            return 'table-red';
        }
    } else {
        return 'table-red';
    }
    
}